import { combineReducers } from "redux";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { unAuthorized } from "../../../auth/Auth.ducks";

export const GET_FERMETURES_PENDING = "GET_FERMETURES_PENDING";
export const GET_FERMETURES_REJECTED = "GET_FERMETURES_REJECTED";
export const GET_FERMETURES_FULFILLED = "GET_FERMETURES_FULFILLED";

export const ADD_FERMETURES_PENDING = "ADD_FERMETURES_PENDING";
export const ADD_FERMETURES_REJECTED = "ADD_FERMETURES_REJECTED";
export const ADD_FERMETURES_FULFILLED = "ADD_FERMETURES_FULFILLED";

export const DELETE_FERMETURES_PENDING = "DELETE_FERMETURES_PENDING";
export const DELETE_FERMETURES_REJECTED = "DELETE_FERMETURES_REJECTED";
export const DELETE_FERMETURES_FULFILLED = "DELETE_FERMETURES_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_FERMETURES_PENDING:
    case ADD_FERMETURES_PENDING:
    case DELETE_FERMETURES_PENDING:
      return true;

    case GET_FERMETURES_REJECTED:
    case GET_FERMETURES_FULFILLED:
    case ADD_FERMETURES_REJECTED:
    case ADD_FERMETURES_FULFILLED:
    case DELETE_FERMETURES_REJECTED:
    case DELETE_FERMETURES_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case GET_FERMETURES_PENDING:
    case GET_FERMETURES_FULFILLED:
    case ADD_FERMETURES_PENDING:
    case ADD_FERMETURES_FULFILLED:
    case DELETE_FERMETURES_PENDING:
    case DELETE_FERMETURES_FULFILLED:
      return null;
    case GET_FERMETURES_REJECTED:
    case ADD_FERMETURES_REJECTED:
    case DELETE_FERMETURES_REJECTED:
      return payload;
    default:
      return state;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_FERMETURES_FULFILLED:
    case ADD_FERMETURES_FULFILLED:
    case DELETE_FERMETURES_FULFILLED:
      return _.isEmpty(payload.data) ? {} : payload.data;

    default:
      return state;
  }
};

export default combineReducers({ loading, error, data });

export const getFermetures = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_FERMETURES_PENDING });
    const response = Service.get(`${API}api/creche/fermetures`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_FERMETURES_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_FERMETURES_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
export const postFermetures = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: ADD_FERMETURES_PENDING });
    const response = Service.post(`${API}api/creche/fermetures`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: ADD_FERMETURES_FULFILLED, payload: res });
      dispatch(getFermetures(tok));
    });
    response.catch((error) => {
      let message = !_.isEmpty(error.response)
        ? error.response.data.message
        : error.response;

      dispatch({ type: ADD_FERMETURES_REJECTED, payload: error });
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });

      if (error.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
export const deleteFermetures = (tok, idEvent) => {
  return (dispatch) => {
    dispatch({ type: DELETE_FERMETURES_PENDING });
    const response = Service.deleteOne(
      `${API}api/creche/fermetures/${idEvent}`,
      {
        headers: { Authorization: `Bearer ${tok}` },
      }
    );
    response.then((res) => {
      dispatch({ type: DELETE_FERMETURES_FULFILLED, payload: res });
      dispatch(getFermetures(tok));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: DELETE_FERMETURES_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
